/**
 * Workspace section keys + URL param parsing.
 */
import type { RefObject } from "react";

export const SECTION_KEYS = [
  "gearList",
  "quote",
  "jobDetails",
  "jobSummary",
  "crew",
  "clientPayment",
  "contractorPayment",
] as const;

export type SectionKey = (typeof SECTION_KEYS)[number];

export function isSectionKey(v: string): v is SectionKey {
  return (SECTION_KEYS as ReadonlyArray<string>).includes(v);
}

/** Accept kebab-case in URLs (`?section=client-payment`) → camelCase key. */
export function parseSectionParam(
  v: string | null | undefined,
): SectionKey | null {
  if (!v) return null;
  if (isSectionKey(v)) return v;
  const camel = v.replace(/-([a-z])/g, (_, c: string) => c.toUpperCase());
  return isSectionKey(camel) ? camel : null;
}

export type SectionRefs = Record<SectionKey, RefObject<HTMLDivElement | null>>;
